import { AdvisorsLayout, AdvisorProfileViewSection } from '@src/components/sco/Advisors'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default function Page() {
  return (
    <AdvisorsLayout>
      <AdvisorProfileViewSection />
    </AdvisorsLayout>
  )
}
